import { render, staticRenderFns } from "./display-field-percent.vue?vue&type=template&id=a0836778&scoped=true&"
import script from "./display-field-percent.ts?vue&type=script&lang=ts&"
export * from "./display-field-percent.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-percent.scss?vue&type=style&index=0&id=a0836778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0836778",
  null
  
)

export default component.exports